var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useConfigContext, useJobsContext } from '@/hoc';
import { useJobSearchSuggestion } from '@/hooks';
import { cn } from '@/utils';
import { SearchIcon } from './icons';
import { BaseInput, Button } from './ui';
export var JobSearchInput = function () {
    var _a, _b, _c;
    var _d = useJobsContext(), filters = _d.filters, setFilters = _d.setFilters;
    var layout = useConfigContext().config.layout;
    var onSearch = function (_a) {
        var query = _a.query, suggestion = _a.suggestion;
        if (suggestion) {
            var isFilterAlreadyExist = filters.appliedFilters.some(function (filter) { return filter.queryKey === suggestion.type && filter.value === suggestion.id; });
            if (!isFilterAlreadyExist) {
                setFilters(function (prevFilters) { return ({
                    selectedSuggestion: suggestion,
                    appliedFilters: __spreadArray(__spreadArray([], prevFilters.appliedFilters, true), [
                        {
                            queryKey: suggestion.type,
                            value: suggestion.id,
                            label: suggestion.name,
                        },
                    ], false),
                }); });
            }
        }
        else {
            setFilters(function (prevFilters) { return (__assign(__assign({}, prevFilters), { search: query })); });
        }
    };
    var _e = useJobSearchSuggestion({
        onSearch: onSearch,
        searchQuery: (_c = (_a = filters.search) !== null && _a !== void 0 ? _a : (_b = filters.selectedSuggestion) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '',
        selectedSuggestionFilter: filters.selectedSuggestion,
    }), query = _e.query, handleSearch = _e.handleSearch, suggestions = _e.suggestions, isLoading = _e.isLoading, showSuggestions = _e.showSuggestions, handleSubmit = _e.handleSubmit, handleSuggestionClick = _e.handleSuggestionClick, searchRef = _e.searchRef, setShowSuggestions = _e.setShowSuggestions;
    return (_jsxs("div", { ref: searchRef, className: cn('relative w-full max-w-lg', {
            'ml-auto': (layout === null || layout === void 0 ? void 0 : layout.searchPosition) === 'left',
        }), children: [_jsx("form", { onSubmit: handleSubmit, className: 'relative', children: _jsxs("div", { className: 'flex text-gray-400 gap-1 ps-2 bg-white border border-gray-300 rounded-full overflow-hidden w-full focus-within:border-vjwPrimary focus-within:border-2 hover:border-black focus-within:hover:border-vjwPrimary', children: [_jsx(SearchIcon, { size: 'large' }), _jsx(BaseInput, { type: 'text', value: query, onChange: function (e) { return handleSearch(e.target.value); }, onFocus: function () { return setShowSuggestions(true); }, placeholder: 'Search Jobs', className: '!border-none focus:!outline-none !w-full !px-4 !py-2 !text-gray-700' }), _jsx(Button, { type: 'submit', children: "Search" })] }) }), showSuggestions && (suggestions.length > 0 || isLoading) && (_jsx("div", { className: 'absolute z-100000 w-10/12 mt-1 bg-white border border-gray-300 rounded-md shadow-lg', children: isLoading ? (_jsx("div", { className: 'p-4 text-center text-gray-500', children: "Loading..." })) : (_jsx("ul", { children: suggestions.map(function (suggestion) { return (_jsx("li", { onClick: function () { return handleSuggestionClick(suggestion); }, className: 'px-4 py-2 cursor-pointer hover:bg-vjwSecondary', children: suggestion.name }, suggestion.id)); }) })) }))] }));
};
